import { PRICING } from '@/common/constants/pricing';

export default function getPlanNameFromMiles(
  milesPerMonth: number | undefined
): string | undefined {
  if (milesPerMonth === undefined) {
    return undefined;
  }

  switch (milesPerMonth) {
    case 0:
      return PRICING.PLAN_NAMES.ZERO_MILE;
    case 500:
      return PRICING.PLAN_NAMES.FIVE_HUNDRED_MILE;
    case 850:
      return PRICING.PLAN_NAMES.EIGHT_FIFTY_MILE;
    case 1200:
      return PRICING.PLAN_NAMES.TWELVE_HUNDRED_MILE;
    case 2000:
      return PRICING.PLAN_NAMES.EXTRA_HIGH_MILE;
    /** For cases where customer is on a 500 mile plan, format in our old copy style */
    default:
      return `${milesPerMonth} ${PRICING.PLAN_NAMES.PLAN_MILE_SUFFIX}`;
  }
}
